module.exports = __webpack_public_path__ + "img/simplex.ef084bfd.png";